import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

const STORAGE_KEY_PREFIX = 'seve.project.autoSave.';

@Injectable({ providedIn: 'root' })
export class ProjectAutoSaveService {
  private unsavedChanges = false;

  constructor(private authService: AuthService) {}

  get hasUnsavedChanges(): boolean {
    return this.unsavedChanges;
  }

  isEnabled(projectId: string | null): boolean {
    if (!projectId) return true;
    return this.tryStorage(() => localStorage.getItem(this.storageKey(projectId)) !== 'false', true);
  }

  setEnabled(projectId: string | null, enabled: boolean): void {
    if (!projectId) return;
    if (enabled) {
      this.clear(projectId);
      return;
    }
    this.tryStorage(() => localStorage.setItem(this.storageKey(projectId), 'false'));
  }

  clear(projectId: string | null): void {
    if (!projectId) return;
    this.tryStorage(() => localStorage.removeItem(this.storageKey(projectId)));
  }

  markUnsaved(): void {
    this.unsavedChanges = true;
  }

  markSaved(): void {
    this.unsavedChanges = false;
  }

  private storageKey(projectId: string): string {
    const userId: string | undefined = this.authService.userValue?.userId;
    return userId ? `${STORAGE_KEY_PREFIX}${userId}.${projectId}` : `${STORAGE_KEY_PREFIX}${projectId}`;
  }

  private tryStorage(operation: () => void): void;
  private tryStorage<T>(operation: () => T, fallback: T): T;
  private tryStorage<T>(operation: () => T, fallback?: T): T | undefined {
    try {
      return operation();
    } catch {
      return fallback;
    }
  }
}
